/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Close } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import Switch, { SwitchProps } from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@mui/material';
import useProductSamplingContext from '../context/useProductSamplingContext';

export default function ProductDetails() {
  const { auth, activeTab, updateProductModal, setUpdateProductModal, handleUpdateProduct } =
    useContext(useProductSamplingContext);

  const handleOnChange = (event) => {
    setUpdateProductModal({
      ...updateProductModal,
      product: { ...updateProductModal.product, product_name: event.target.value },
    });
  };

  const handleOnChangeSwitch = (event) => {
    setUpdateProductModal({
      ...updateProductModal,
      product: {
        ...updateProductModal.product,
        is_published: event.target.checked === true ? 1 : 0,
      },
    });
  };

  const handleOnChangeVisibleto = (event, row, i) => {
    const newArr = [...updateProductModal.product.segments];
    newArr[i] = {
      segment_id: newArr[i].segment_id,
      segment_name: newArr[i].segment_name,
      is_visible: event.target.checked === true ? 1 : 0,
    };

    setUpdateProductModal({
      ...updateProductModal,
      product: {
        ...updateProductModal.product,
        segments: newArr,
      },
    });
  };

  const handleClose = () => {
    setUpdateProductModal({ ...updateProductModal, toggle: false, product: {} });
  };
  return (
    <Dialog onClose={handleClose} open={updateProductModal.toggle} fullWidth maxWidth='md'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Product Details
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid md={2}>Product Name</Grid>
          <Grid md={10}>
            <TextField
              fullWidth
              id='product_name'
              name='product_name'
              size='small'
              value={updateProductModal?.product?.product_name}
              onChange={(event) => handleOnChange(event)}
            />
          </Grid>

          <Grid md={2}>Visible To</Grid>
          <Grid md={10}>
            {updateProductModal?.product?.segments?.length > 1
              ? updateProductModal?.product?.segments?.map((row, i) => (
                  <Grid md={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={row.is_visible === 1}
                          name={row.segment_id}
                          onChange={(event) => handleOnChangeVisibleto(event, row, i)}
                        />
                      }
                      label={row.segment_name}
                    />
                  </Grid>
                ))
              : ''}
          </Grid>

          <Grid md={2}>Publish Product</Grid>
          <Grid md={10}>
            <Switch
              checked={updateProductModal?.product?.is_published === 1}
              color='success'
              onChange={(event) => handleOnChangeSwitch(event)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={handleUpdateProduct}>
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
